var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.size,style:(("background-image: url('" + _vm.imageUrl + "');")),attrs:{"id":"avatar"}})}
var staticRenderFns = []

export { render, staticRenderFns }